// Content-specific cleanup and transformations for NorthStar project
export function applyContentCleanup(content, citations = []) {
  
  // Wrap sections with headers specifically containing "for Engineers"
  // Only match headers where "for engineers" is at or near the end (not buried in middle)
  // Examples: "Guide for Engineers", "Technical Details for Network Engineers"
  // Captures the header and content until the next header
  content = content.replace(
    /(<h[1-6][^>]*>.*?for [Ee]ngineers?[:\s]{0,3}<\/h[1-6]>)((?:(?!<h[1-6]).)*)/gis,
    '<div class="engineer-info">$1$2</div>'
  );

  // Remove PLMN prefixes/suffixes from headers since we only show S-NSSAI values
  // "S-NSSAI/PLMN" → "S-NSSAI"
  content = content.replace(/S-NSSAI\/PLMN/gi, 'S-NSSAI');
  // "PLMN-S-NSSAI" → "S-NSSAI"
  content = content.replace(/PLMN-S-NSSAI/gi, 'S-NSSAI');

  // Extract S-NSSAI from combined PLMN+S-NSSAI identifiers
  // Examples: "240 491-2018" → "1-2018", "999 0491-50" → "1-50"
  // PLMN = MCC (3 digits) + MNC (2-3 digits), S-NSSAI = SST (1 digit) + SD (2-4 digits)
  // Extract only S-NSSAI portion, as PLMN context is unnecessary in text references

  // Handle both labeled and unlabeled identifiers
  // "PLMN 240 491-2018" → "1-2018" or "PLMN 240491-2018" → "1-2018"
  // "240 491-50" → "1-50" or "240491-50" → "1-50" (supports 2-4 digit SD values)
  content = content.replace(
    /(?:PLMN )?(?:\d{3}\s?)(?:\d{2,3})(\d-\d{2,4})/gi,
    '$1'
  );

  // Replace "S-NSSAI (PLMN XXX YY# prefix)" with "S-NSSAI defined for PLMN XXX YY#"
  // Handles both 2-digit and 3-digit MNC
  content = content.replace(
    /([Ss]-NSSAI) \(PLMN (\d{3}) (\d{2,3})\d prefix\)/g,
    '$1 defined for PLMN $2 $3'
  );

  // Clean up local citations - remove all variants
  // Handles: [local: ...], [local-doc: ...], [local], [local-doc], [local context: ...]
  content = content.replace(/\[local(?:-doc)?(?::\s*[^\]]+)?\]/gi, '');
  content = content.replace(/\[local\s+context(?::\s*[^\]]+)?\]/gi, '');

  // Remove "(From local context)" and similar references
  content = content.replace(/\(From local context\)/gi, '');
  content = content.replace(/\[Local context\]/gi, '');

  // Remove document reference tags like [Previous: filename.pdf], [Next: ...], etc.
  content = content.replace(/\[(Previous|Next|See|Ref|Reference):\s*[^\]]+\]/gi, '');

  // Remove percentage sign from specific "1-1%" pattern only
  content = content.replace(/1-1%/g, '1-1');

  // Remove duplicate citation patterns with :search, :related, etc.
  // Example: [1:search] appears alongside [1], so we remove the :search variant
  content = content.replace(/\[(\d+):[a-z]+\]/gi, '');

  // Citations - format valid citation numbers as superscript links
  if (citations.length > 0) {
    content = content.replace(
      /\[(\d+)\]/g,
      '<sup><a href="#citation-$1" class="citation-link">[$1]</a></sup>'
    );
  }

  return content;
}
